import Head from 'next/head'
import Image from "next/legacy/image";
import styles from "../../styles/pages/Rooms.module.scss"
import Link from 'next/link'
import Topbanner from '../../components/Topbanner/Topbanner'
import { roomsData } from '../../data/roomsData';
import Slider from "react-slick";
import { useState } from 'react';
import Schema from '../../components/Schema';
import BookNowButton from '../../components/BestDeal/BookNowButton';

export default function Room({ room, allRooms }) {
    const [filteredRoom, setFilteredroom] = useState(allRooms)
    let filteredArray = filteredRoom.filter(item => item.slug !== room.slug)
    const otherRooms = filteredArray

    const roomamenities = room.amenities
    const galleryImg = room.gallery

    const gallery_slider = {
        dots: false,
        infinite: false,
        arrows: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const settings = {
        dots: true,
        infinite: true,
        arrows: false,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Schema name={room.SingleRoomSchema} />
            <Head>
                <link rel="icon" href="/favicon.svg" />
                <title>{room.metaTitle}</title>
                <meta
                    name="description"
                    content={room.metaDesc}
                    key="desc"
                />
                <link rel="canonical" href={`https://www.hoteltwintowers.com/hotel-room-in-shimla/${room?.slug}`} />
            </Head>
            <Topbanner bgImage={room.banner} title={room.roomName} />
            <section className={`${styles.single_blog} common_padding`}>
                <div className='container'>
                    <div className='common_title text-center pb-4'>
                        <h2>Description</h2>
                        <p>{room.roomDesc}</p>
                    </div>
                    <div className={styles.gallery_main}>
                        <Slider {...gallery_slider} className="single_room_slider">
                            <div className={styles.gallery_child} >
                                <img src={galleryImg.imageone} alt="Single Room Image" />
                            </div>
                            <div className={styles.gallery_child} >
                                <img src={galleryImg.imagetwo} alt="Single Room Image" />
                            </div>
                            <div className={styles.gallery_child} >
                                <img src={galleryImg.imagethree} alt="Single Room Image" />
                            </div>
                            <div className={styles.gallery_child} >
                                <img src={galleryImg.imageone} alt="Single Room Image" />
                            </div>
                            <div className={styles.gallery_child} >
                                <img src={galleryImg.imagefive} alt="Single Room Image" />
                            </div>
                        </Slider>
                    </div>

                    <div className={`${styles.booking_cont} row justify-content-center common_title`}>
                        <div className={`${styles.booking_col} col-lg-4 col-md-8 col-sm-8`}>
                            <h4>Grab The Best Deal</h4>
                        </div>
                        <div className={`${styles.button_col} col-lg-2 col-md-4 col-sm-4`} >
                            <BookNowButton style={{ width: '100%', height: '100%', margin: '0' }} />
                            {/* <Link target="_blank" href="https://thetwintowers.bookingjini.com/property" className={styles.check_now_btn}>Book Now</Link> */}
                            {/* <a href="https://thetwintowers.bookingjini.com/property" target="_blank" rel="noopener noreferrer" className={styles.check_now_btn}>
                                Book Now
                            </a> */}
                        </div>
                    </div>

                    {/* <div className='row justify-content-center py-4'>
                        <div className='col-md-8'>
                            <div className={`${styles.booking_cont} row common_title`}>
                                <div className={`${styles.booking_col} col`}>
                                    <p>Check In</p>
                                    <h4>26 Nov, 2022</h4>
                                </div>
                                <div className={`${styles.booking_col} col`}>
                                    <p>Check Out</p>
                                    <h4>26 Nov, 2022</h4>
                                </div>
                                <div className={`${styles.booking_col} col`}>
                                    <p>Persons</p>
                                    <h4>2</h4>
                                </div>
                                <div className={`${styles.button_col} col`} >
                                    <Link href="/" className={styles.check_now_btn}>Book Now</Link>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {/* <div className='common_title text-center pt-4'>
                        <h2>Special check-in instructions</h2>
                        <p>Lorem ipsum dolor sit amet consectetur. Cursus vulputate et tellus egestas eget diam. Ultrices habitasse imperdiet in tempus congue sodales eget cursus sed. Eget nunc non proin euismod mauris id urna ac lobortis. Ac ante dictum adipiscing platea vulputate tempor ac. Tristique at orci morbi libero at augue viverra. Lorem ipsum dolor sit amet consectetur.</p>
                    </div> */}

                    <div className={`${styles.amenities_main} row justify-content-center`}>
                        <div className='col-md-8 py-4'>
                            <div className='row common_title text-center'>
                                <h2>
                                    Room Amenities
                                </h2>
                                {roomamenities.map((item, index) => (
                                    <div className={`${styles.amenities_child} col-md-4 col-sm-6 pt-4`} key={index}>
                                        <Image src={item.icon} width={45} height={38} className={styles} alt="Amenities icon" />
                                        <p>{item.title}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className={`${styles.similar_rooms} `}>
                        <div className='row common_title'>
                            <h2 className='text-center'>Similar Rooms</h2>
                            <Slider {...settings} className="activity_slider similar_room_slide">
                                {otherRooms.map((item, index) => (
                                    <div className="" key={index}>
                                        <Link href={`/hotel-room-in-shimla/${item.slug}`} className={styles.similar_room_child}>
                                            <div className={`${styles.bg_image} m-0`} style={{ backgroundImage: `url(${item.roomsImage})` }}>
                                                {/* <span>{item.roomPrice}</span> */}
                                            </div>
                                            <div className={`${styles.similer_inner_text} common_title m-0`}>
                                                <h2>{item.roomName}</h2>
                                                <p>{item.shortDesc}</p>
                                                <div className={styles.rooms_center_amen}>
                                                    <img src="/icons/bed.svg" alt="bed icon" />
                                                    <img src="/icons/guests.svg" alt="guests icon" />
                                                    <img src="/icons/coffee.svg" alt="coffee icon" />

                                                    {/* <div>
                                                    <Image src="/icons/bed.svg" height={20} width={23} alt="icon"></Image>
                                                    <p className=''>{item.beds}</p>
                                                </div>
                                                <div className={styles.right_amen}>
                                                    <Image src="/icons/guests.svg" height={20} width={23} alt="icon"></Image>
                                                    <p className=''> {item.guests}</p>
                                                </div> */}

                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export const getStaticProps = async ({ params }) => {
    const allRooms = roomsData
    const currentSlug = params.slug;
    const room = roomsData.find((room) => room.slug === currentSlug) || {
        notfound: true,
    };
    return { props: { room, allRooms } };
};

export const getStaticPaths = async () => {
    const paths = roomsData.map((room) => ({
        params: { slug: room.slug },
    }));
    return { paths, fallback: false };
};